import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import c from './assets/sass/timer.module.scss'

export const LeaderboardTimer = ({ endDate }) => {
    const { t } = useTranslation()
    const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 })

    useEffect(() => {
        const calc = () => {
            const now = new Date()
            const end = new Date(endDate)
            const diff = Math.max(0, end - now)

            setTimeLeft({
                days: Math.floor(diff / (1000 * 60 * 60 * 24)),
                hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((diff / (1000 * 60)) % 60),
                seconds: Math.floor((diff / 1000) % 60),
            })
        }

        calc()
        const interval = setInterval(calc, 1000)
        return () => clearInterval(interval)
    }, [endDate])

    const pad = (n) => String(n).padStart(2, '0')

    return (
        <div className={c.component}>
            <div className={c.time}>
                {timeLeft.days}д : {pad(timeLeft.hours)}ч : {pad(timeLeft.minutes)}м : {pad(timeLeft.seconds)}с
            </div>
            <div className={c.label}>{t('pages.leaderboard.timer')}</div>
        </div>
    )
}
